import React from "react";
import PdfViewer from "../../PdfViewer";

const ProcesoCompletoIT = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/proceso-comercial-completo.pdf`;
  /*const pdfUrl = "/pdf/proceso-comercial-completo.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Proceso Comercial Completo</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default ProcesoCompletoIT;
